module.exports = __webpack_public_path__ + "img/img7.68dd3ea8.png";